import React, { useEffect, useRef } from 'react';
import { useAlert } from 'react-alert';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import get from 'lodash/get';
import css from './PersistentDeclinedToast.css';

/**
 * Persistent toast component that shows a non-dismissible alert
 * when user's verification status is declined
 */
const PersistentDeclinedToastComponent = ({ currentUser }) => {
  const alert = useAlert();
  const history = useHistory();
  const alertInstanceRef = useRef(null);

  useEffect(() => {
    // Check if user is declined
    if (!currentUser || !currentUser.attributes || !currentUser.attributes.profile) {
      return;
    }

    const verificationStatus = get(
      currentUser,
      'attributes.profile.publicData.guestIdentityVerificationStatus',
      null
    );

    const isDeclined = verificationStatus === 'declined';

    if (isDeclined) {
      // Show persistent toast
      const alertMessage = (
        <div className={css.persistentToastContent} onClick={() => {
          // Navigate to verification page when clicked
          history.push('/account/driving-verification');
        }}>
          <div className={css.persistentToastTitle}>
            <FormattedMessage id="identityVerification.persistentToast.title" />
          </div>
          <div className={css.persistentToastMessage}>
            <FormattedMessage id="identityVerification.persistentToast.message" />
          </div>
        </div>
      );

      // Show alert without close button (persistent)
      if (!alertInstanceRef.current) {
        alertInstanceRef.current = alert.show(alertMessage, {
          type: 'error',
          timeout: 0, // Never auto-close - makes it persistent
        });
      }
    } else {
      // Remove alert if user is no longer declined
      if (alertInstanceRef.current) {
        alert.remove(alertInstanceRef.current);
        alertInstanceRef.current = null;
      }
    }

    // Cleanup on unmount
    return () => {
      if (alertInstanceRef.current) {
        alert.remove(alertInstanceRef.current);
        alertInstanceRef.current = null;
      }
    };
  }, [currentUser, alert, history]);

  return null; // This component doesn't render anything directly
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
  };
};

const PersistentDeclinedToast = connect(mapStateToProps)(PersistentDeclinedToastComponent);

export default PersistentDeclinedToast;

